export default __webpack_public_path__ + "static/media/t1.bea837ea.jpeg";